// watcher.js defines watchers on store state variables and getters in the same way as vue components define watchers.

export default {
    getters: {
        application: {
            handler(after, before, context) {
                // only update dirty to true if its the same application (if we open a new application, thats not making it dirty)
                // other wise its the original dirty value
                let dirty = context.getters.application_status.dirty || after == before;
                context.commit('setApplicationStatus', { dirty });
            },
            deep: true,
        },
    },
    state: {

    },
};